// API base URL utility
// In development (with proxy), use relative URLs
// In production, use REACT_APP_API_URL

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const getApiUrl = (path: string): string => {
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export default API_BASE_URL;
